import { css as e, styled as t } from "styled-components";
import { Theme as o } from "../../styles/themes/index.js";
import { SmallHeavy as s, BodyHeavy as d } from "../../styles/typography/index.js";
import { skeletonFadeAnimation as l } from "../../styles/animation.js";
const a = e`
  ${s}
  height: 24px;
  padding: 4px 8px;
  border-radius: 12px;
  border: 1px solid rgb(${o.colors.Golf});
  align-items: center;
`, n = e`
  ${d}
  height: 40px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgb(${o.colors.Bravo});
`, i = {
  SMALL: a,
  BIG: n
}, g = t.div`
  ${({ size: r }) => i[r]}
  background-color: rgb(${o.colors.India});
  display: flex;

  width: fit-content;

  &[aria-selected='true'] {
    background-color: rgb(${o.colors.Bravo});
    border: 1px solid rgb(${o.colors.Sierra});
  }

  &[role='button'] {
    cursor: pointer;
  }
`, m = t.div`
  width: 120px;
  border-radius: 8px;

  ${({ size: r }) => i[r]}
  ${l}
`;
export {
  g as TextCapsuleContainer,
  m as TextCapsuleContainerSkeleton,
  i as sizeStyles
};
